exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "disponibilidad-form .row>h4{margin-bottom:20px;margin-top:20px}disponibilidad-form .row>div{margin-top:20px}disponibilidad-form .btn-dia{min-width:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/disponibilidades/form/form.scss
// module id = 1727
// module chunks = 0